import _ from 'lodash';

export default (function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelContext) {
    var translateFn = TranslateService.instant;

    function wrappedLoadSave(action, model) {
        console.log('wc FlowConfig.wrappedLoadSave Save submission');
        var promise = action.call(undefined, model);
        return promise.then(function (submissionDTO) {
            return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelContext);
        });
    }

    var ACTION_MSGS = {
        saveSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Saving quote...'
            }
        }
    };

    var ACTIONS = {
        saveDraftSubmission: function saveDraftSubmission(_ref) {
            var submission = _ref.value;
            return wrappedLoadSave(LoadSaveService.saveSubmission, submission);
        }
    };
    /*
    const ACTIONS = {
        saveDraftSubmission: ({
                                  value: submission
                              }) => LoadSaveService.saveDraftSubmissionAndPrimaryLocation(submission).then(
            submissionDTO => ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelContext)
        )
    };
    */

    return {
        contactDetails: function contactDetails(step, junction) {
            step('wcContactDetails', true) // what is the second parameter - entry point?
            .onNext.branch(function (model) {
                return model.quoteID.value ? 'wcPostContactDetails' : 'wcContactDetailsComplete';
            }).skipOnResumeIf(function (_ref2) {
                var submission = _ref2.value;
                return submission.persons[0] && submission.persons[0].emailAddress1;
            }) // persons will not work here?
            .isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Your Info');
            });

            junction('wcPostContactDetails').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission).thenGoTo('wcContactDetailsComplete', 'error');

            junction('wcContactDetailsComplete');
        },
        coverables: function coverables(step, junction) {
            step('wcPrequalQuestions', true).onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission).thenGoTo('wcNamedInsured', 'error').skipOnResumeIf(function (_ref3) {
                var submission = _ref3.value;

                if (submission.baseData.mSFPrequalQue_EXT) return true;
                return false;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Qualification');
            });

            step('wcNamedInsured').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission).thenGoTo('wcLocations', 'error').skipOnResumeIf(function (_ref4) {
                var submission = _ref4.value;

                if (submission.baseData.mSFNamedInsuredVal_EXT) return true;
                return false;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Named Insured');
            });

            step('wcLocations').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission).thenGoTo('wcStateCoverages', 'error').skipOnResumeIf(function (_ref5) {
                var submission = _ref5.value;

                if (submission.baseData.mSFIsLocation_EXT) return true;
                return false;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Locations');
            });

            step('wcStateCoverages').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission).thenGoTo('wcPolicyCoverages', 'error').skipOnResumeIf(function (_ref6) {
                var submission = _ref6.value;

                if (submission.baseData.mSFIsStateCov_EXT) return true;
                return false;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.State Coverages');
            });

            step('wcPolicyCoverages').onNext.goTo('wcGeneralInfoQuestions').skipOnResumeIf(function (_ref7) {
                var submission = _ref7.value;

                if (submission.baseData.mSFIsPolicyCov_EXT) return true;
                return false;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Policy Coverages');
            });

            step('wcGeneralInfoQuestions').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission).thenGoTo('wcOwnersAndOfficers').skipOnResumeIf(function (_ref8) {
                var submission = _ref8.value;

                if (submission.baseData.mSFGeneralInfoQue_EXT) return true;
                return false;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.General Information');
            });

            step('wcOwnersAndOfficers').onNext.goTo('wcCoverablesComplete').skipOnResumeIf(function (_ref9) {
                var submission = _ref9.value;

                return false;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Owners and Officers');
            });

            /* Removing these steps and using the ootb steps instead
                        step('wcPolicyReview')
                            .onNext.goTo('wcQuote')
                            .skipOnResumeIf(({ value: submission }) => {
                                return false
                            })
                            .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                            .label(() => translateFn('quoteandbind.wizard.step.Policy Review'));
            
                        step('wcQuote')
                            .onNext.goTo('wcPayments')
                            .skipOnResumeIf(({ value: submission }) => {
                                return false
                            })
                            .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                            .label(() => translateFn('quoteandbind.wizard.step.Quote'));
            
                        step('wcPayments')
                            .onNext.goTo('wcConfirmation')
                            .skipOnResumeIf(({ value: submission }) => {
                                return false
                            })
                            .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                            .label(() => translateFn('quoteandbind.wizard.step.Payments'));
            
                        step('wcConfirmation')
                            .onNext.goTo('wcCoverablesComplete')
                            .skipOnResumeIf(({ value: submission }) => {
                                return false
                            })
                            .isValid(model => model.aspects.valid && model.aspects.subtreeValid)
                            .label(() => translateFn('quoteandbind.wizard.step.Confirmation'));
            */

            junction('wcCoverablesComplete');
        },
        moreInfo: function moreInfo(step, junction) {
            step('wcPolicyInfo', true).onNext.goTo('wcMoreInfoComplete').skipOnResumeIf(function (_ref10) {
                var submission = _ref10.value;

                return submission.baseData && submission.baseData.accountHolder && submission.baseData.accountHolder.emailAddress1 && (submission.baseData.accountHolder.homeNumber || submission.baseData.accountHolder.workNumber || submission.baseData.accountHolder.cellNumber);
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Policy Info');
            });

            junction('wcMoreInfoComplete');
        }

    };
});


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=wc!./app/customer/js/src/edge/quoteandbind/wc/config/FlowConfig.js
// module id = 486
// module chunks = 0